module.exports = require("video.js/dist/video-js.css");